import { useEffect, useRef, useState } from "react";
import { Spin, Select, DatePicker, Checkbox, Form, Button, Table, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getProductStatus } from "../../redux/actions/productStatus.actions";

import { getGender } from "../../redux/actions/gender.action";
import { ReadCookie } from "../../utils/readCookie";
import { getStyle } from "../../redux/actions/style";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";

import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { getOmsStockStyleWiseSummary } from "../../redux/actions/omsStockStyleWiseSummary.action";
import numeral from "numeral";
import { getBrands } from "../../redux/actions/brand.action";
import filterHelper from "../../utils/filterHelper";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF";
const dateFormatList = ["MM-DD-YYYY"];

const OMSStockStyleWiseSummary = ({ token }) => {
    TabTitle("Stock Style Wise Summary")
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const {
        style,
        gender,
        productStatus,
        omsStockStyleWiseSummary,
        styleChange,
        brand
    } = useSelector((state) => state);
    const menuId = ReadCookie("menuId");
    const userName = ReadCookie("name");
    const tableRef = useRef(null);
    const [isChecked2, setIsChecked2] = useState([]);
    const [allStatus, setAllStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([])
    const [excelData, setExcelData] = useState([])
    const [genderName, setGenderName] = useState(null);
    const [brandName, setBrandName] = useState(null);
    const [styleName, setStyleName] = useState(null);
    const [sortedInfo, setSortedInfo] = useState({});
    const [paginationInfo, setPaginationInfo] = useState({
        current: 1,
        pageSize: 500,
        total: 0,
    });
    const initialDate = moment('2026-12-31')
    const { Option } = Select;

    const statusSelectAll = (e) => {
        setAllStatus(e.target.checked);
    };

    const isCheckboxChecked2 = (id, value) => {
        const filterCheckBox =
            productStatus && productStatus?.payload?.data.find((val) => val.product_status_id === id);
        const checkId = isChecked2.includes(id);
        if (!checkId) {
            setIsChecked2((current) => [...current, filterCheckBox.product_status_id]);
        }
        if (!value) {
            const removeUnCheck = isChecked2.filter(
                (item) => item !== filterCheckBox.product_status_id
            );
            setIsChecked2(removeUnCheck);
        }
        setAllStatus(false);
    };

    const onFinish = async (e) => {
        setLoading(true)
        await form.validateFields().then((values) => {
            dispatch(
                getOmsStockStyleWiseSummary(token, values, [], isChecked2, [], false)).then((res => {
                    setLoading(false)
                    setData(res?.payload?.data)
                    downloadExcelFileData(res?.payload?.data);
                }));
        });
    };

    const itemCodeTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.no_item_code), 0)
    const berganTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.bergan), 0)
    const transitTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.transit), 0)
    const pkTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.pakistan), 0)
    const productionTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.production), 0)
    const pendingTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.pending), 0)
    const internationalTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.international), 0)
    const otsTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.ots), 0)
    const nordTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.nord), 0)
    const ltD2c = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.lt_d2c), 0)
    const podTotal = omsStockStyleWiseSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.pod), 0)


    function downloadExcelFileData(data) {
        if (data.length > 0) {
            setExcelData(
                data.map((v) => {
                    return {
                        "Gender": v.gender_name,
                        "Style": v.style_name,
                        "Brand": v.brand_name,
                        "No of SKU": v.no_item_code,
                        "Bergen": v.bergan,
                        "Transit": v.transit,
                        "Bulk DL": v.pakistan,
                        "Bulk WW": v.production,
                        "P. Order": v.pending,
                        "International": v.international,
                        "OTS": v.ots,
                        "POD": v.pod,
                    };
                })
            )
        }
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);

        setPaginationInfo({
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: (data ? data.length : 0),
        });
    };

    const getSortedData = (data, sortedInfo) => {
        if (!sortedInfo.order) return data;

        const { columnKey, order } = sortedInfo;
        return [...data].sort((a, b) => {
            const aValRaw = a[columnKey];
            const bValRaw = b[columnKey];

            const aVal = Number(
                typeof aValRaw === "string"
                    ? aValRaw.replace(/,/g, "")
                    : aValRaw
            );
            const bVal = Number(
                typeof bValRaw === "string"
                    ? bValRaw.replace(/,/g, "")
                    : bValRaw
            );

            if (isNaN(aVal)) return 1;
            if (isNaN(bVal)) return -1;

            if (order === "ascend") {
                return aVal - bVal;
            } else {
                return bVal - aVal;
            }
        });
    };

    const generatePDF = () => {
        const columns = ["#", "Gender", "Style", "Brand", "No of SKU", "Bergen", "Transit", "Bulk DL", "Bulk WW", "P.Order", "OTS", "POD"];
        const rows = [];
        const sortedData = getSortedData(data, sortedInfo);
        sortedData.forEach((item, index) => {
            const row = [
                index + 1,
                item.gender_name,
                item.style_name,
                item.brand_name,
                item.no_item_code,
                numeral(item.bergan).format('0,0'),
                numeral(item.transit).format('0,0'),
                numeral(item.pakistan).format('0,0'),
                numeral(item.production).format('0,0'),
                numeral(item.pending).format('0,0'),
                numeral(item.ots).format('0,0'),
                numeral(item.pod).format('0,0')
            ];
            rows.push(row);
        });

        generateDynamicPDF({
            filename: 'Stock-Style-Wise-Report-Summary.pdf',
            headers: [
                genderName && { label: 'Gender', value: genderName },
                styleName && { label: 'Style', value: styleName },
                brandName && { label: 'Brand', value: brandName },
                isChecked2.length > 0 && filterProductStatusName?.length > 0 && {
                    label: 'Product Status',
                    value: filterProductStatusName.map(val => val.product_status_name).join(', '),
                },
                form.getFieldValue('as_on_date') && {
                    label: 'Pending Till',
                    value: moment(form.getFieldValue('as_on_date')).format("MM-DD-YYYY"),
                },
            ].filter(Boolean),
            columns,
            rows,
            rowsRaw: sortedData,
            totalFields: ['no_item_code', 'bergan', 'transit', 'pakistan', 'production', 'pending',
                'international', 'ots', 'pod'],
            totalLabelIndex: 3,
            rightAlignIndexes: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            margin: { top: 10, left: 5, right: 5, bottom: 2 }
        });
    };

    useEffect(() => {
        dispatch(getStyle(token, menuId));
        dispatch(getProductStatus(token, menuId));
        dispatch(getGender(token, menuId));
        dispatch(getBrands(token, menuId));
    }, [dispatch, menuId, token]);

    useEffect(() => {
        if (allStatus) {
            setIsChecked2([]);
        }
    }, [allStatus])

    const handlePrint = () => {
        const totalPages = Math.ceil(data?.length / paginationInfo?.pageSize);
        let notificationKey = 'print-warning'
        if (totalPages > 1) {
            notification.warning({
                message: 'Printing Notice',
                description: `Data has ${totalPages} pages. Only page ${paginationInfo.current} will be printed.`,
                duration: 2,
                key: notificationKey
            });
            setTimeout(() => {
                notification.close(notificationKey);
            }, 2000);
            setTimeout(() => {
                notification.close(notificationKey);
                const css = '@page { margin-top: 30px; margin-bottom: 30px }';
                const style = document.createElement('style');
                style.innerHTML = css;
                document.head.appendChild(style);
                window.print();
                document.head.removeChild(style);
            }, 3000); // Wait 2.5 seconds before printing
        } else {
            const css = '@page { margin-top: 30px; margin-bottom: 30px }';
            const style = document.createElement('style');
            style.innerHTML = css;
            document.head.appendChild(style);
            window.print();
            document.head.removeChild(style);
        }
    };

    const columns = [
        {
            title: "S#",
            align: "center",
            width: "60px",
            render: (text, record, index) => {
                return index + 1
            },
        },
        {
            title: "Gender",
            dataIndex: "gender_name",
            key: "gender_name",
            ...filterHelper("gender_name")
        },
        {
            title: "Style",
            dataIndex: "style_name",
            key: "style_name",
            ...filterHelper("style_name")
        },
        {
            title: "Brand",
            dataIndex: "brand_name",
            key: "brand_name",
            ...filterHelper("brand_name")
        },
        {
            title: "No of SKU",
            dataIndex: "no_item_code",
            key: "no_item_code",
            align: "right",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            ...filterHelper("no_item_code", "num")
        },
        {
            title: "Bergen",
            dataIndex: "bergan",
            key: "bergan",
            align: "right",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            ...filterHelper("bergan", "num")
        },
        {
            title: "Transit",
            dataIndex: "transit",
            key: "transit",
            align: "right",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            ...filterHelper("transit", "num")
        },
        {
            title: "Bulk DL",
            dataIndex: "pakistan",
            key: "pakistan",
            align: "right",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            ...filterHelper("pakistan", "num")
        },
        {
            title: "Bulk WW",
            dataIndex: "production",
            key: "production",
            align: "right",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            ...filterHelper("production", "num")
        },
        {
            title: "P. Order",
            dataIndex: "pending",
            key: "pending",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            align: "right",
            ...filterHelper("pending", "num")
        },
        {
            title: <span className="txtbold">OTS</span>,
            dataIndex: "ots",
            key: "ots",
            render: (text, record) => {
                return <span className="txtbold">{numeral(text).format('0,0')}</span>
            },
            align: "right",
            ...filterHelper("ots", "num")
        },
        {
            title: "POD",
            dataIndex: "pod",
            key: "pod",
            render: (text, record) => {
                return <>{numeral(text).format('0,0')}</>
            },
            align: "right",
            ...filterHelper("pod", "num")
        }
    ];

    const filterProductStatusName = productStatus?.payload?.data?.filter(item => isChecked2.includes(item.product_status_id));

    return (
        <div className="header_class business_header_oms">
            <div className="row justify-content-between business_class_oms distributor">
                <div className="col-3 d-flex align-items-start box-space">
                    <div className="logobrand">
                        <img id="ImgLogo" alt="logo" src={logo} />
                    </div>
                </div>
                <div className="col-4 box-space right-content-header text-right">
                    <div className=" d-flex justify-content-end">
                        <div className=" d-flex justify-content-end mr-8 printing_class">
                            <div className="print_icon printing_class">
                                <i
                                    onClick={handlePrint}
                                    id="Image1"
                                    title="Print"
                                    alt="Print"
                                    src={btnPrint}
                                    className="fa-solid fa-print"
                                ></i>
                            </div>
                            <div className="print_icon printing_class">
                                <CSVLink
                                    filename={"Oms-Stock-Style-Wise-Summary.csv"}
                                    data={excelData}
                                    style={{ display: "flex" }}
                                    onClick={() => {

                                    }}
                                >
                                    <input
                                        type="image"
                                        name="ImgExcel"
                                        alt="Export to excel"
                                        id="ImgExcel"
                                        title="Export to excel"
                                        src={xlsx}
                                        style={{ borderWidth: "0px", height: "14px" }}
                                    />
                                </CSVLink>
                            </div>
                            <div className="print_icon printing_class" >
                                <input
                                    type="image"
                                    name="ImgPDF"
                                    alt="Export to PDF"
                                    id="ImgPDF"
                                    title="Export to PDF"
                                    src={pdf}
                                    onClick={generatePDF}
                                    style={{ borderWidth: "0px", height: "18px" }}
                                />
                            </div>

                        </div>
                        <span style={{ fontSize: "small", fontWeight: "bolder" }}>
                            Stock Report Style Wise Summary
                            <br />
                            Rpt # 489
                            <br />
                            <p className=" mb-0">Rpt # 001_V4</p>
                            Login as:{" "}
                            <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                                {userName}
                            </span>
                            <br />
                        </span>
                    </div>
                </div>
            </div>


            <div className="business_class_oms mb-2 distributor">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                    <div className="main_form row">
                        <div className="col-12">
                            <hr className="my-1" />
                            <div>
                                <label htmlFor="">Product Status</label>
                                <div className="checkboxes">
                                    <div className="checkbox_content">
                                        <Form.Item name="current_status_id" className=" mb-0">
                                            <Checkbox checked={allStatus} onChange={statusSelectAll}>
                                                All
                                            </Checkbox>
                                        </Form.Item>
                                    </div>
                                    {productStatus &&
                                        productStatus?.payload?.data.map((it, index) => {
                                            return (
                                                <div key={index} className="checkbox_content">
                                                    <Form.Item name="current_status_id">
                                                        <Checkbox
                                                            checked={allStatus ? false : isChecked2.includes(it.product_status_id)}
                                                            onChange={(e) =>
                                                                isCheckboxChecked2(
                                                                    it.product_status_id,
                                                                    e.target.checked
                                                                )
                                                            }
                                                        >
                                                            {it.product_status_name}
                                                        </Checkbox>
                                                    </Form.Item>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                            <hr className="my-1" />
                            <div className="main_form row">
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">Gender</label>
                                        <div className="w-100">
                                            <Form.Item name="gender_id" initialValue={"All"}>
                                                <Select
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== null ?
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                    }
                                                    onChange={(e, obj) => setGenderName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {gender &&
                                                        gender?.payload?.data.map((it, index) => {
                                                            return (
                                                                <Option key={index} value={it.gender_id}>
                                                                    {it.gender_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">Style</label>
                                        <div className="w-100">
                                            <Form.Item initialValue={"All"} name="style_id">
                                                <Select
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== null ?
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                    }
                                                    size="small"
                                                    onChange={(e, obj) => setStyleName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {
                                                        styleChange && styleChange?.payload?.data.length >= 0 ? (
                                                            styleChange && styleChange?.payload?.data.map((style, index) => {
                                                                return (
                                                                    <Option key={index} value={style.style_id}>
                                                                        {style.style_name}
                                                                    </Option>
                                                                );
                                                            })
                                                        ) : (
                                                            style && style?.payload?.data.map((style, index) => {
                                                                return (
                                                                    <Option key={index} value={style.style_id}>
                                                                        {style.style_name}
                                                                    </Option>
                                                                );
                                                            })
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">Pending Till</label>
                                        <div className="w-100">
                                            <Form.Item
                                                name="as_on_date"
                                                className="full_date"
                                                initialValue={initialDate}
                                            >
                                                <DatePicker
                                                    size="small"
                                                    format={dateFormatList}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">Brand</label>
                                        <div className="w-100">
                                            <Form.Item name="brand_id" initialValue={"All"}>
                                                <Select
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== null ?
                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                    }
                                                    onChange={(e, obj) => setBrandName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {brand &&
                                                        brand?.payload?.data.map((it, index) => {
                                                            return (
                                                                <Option key={index} value={it.brand_id}>
                                                                    {it.brand_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", marginTop: "3px", float: "right" }}>
                                <Button
                                    style={{ width: "fit-content" }}
                                    type="primary"
                                    htmlType="submit"
                                    className="submit-btn-btm m-0"
                                >
                                    Generate
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            <div>
                <div>

                    {omsStockStyleWiseSummary?.payload?.data !== undefined ?
                        (
                            data.length > 0 ? (
                                <div id="card">
                                    <div style={{ display: "flex", gap: 20 }}>
                                        {genderName && <div>Gender: {genderName}</div>}
                                        {styleName && <div>Style: {styleName}</div>}
                                        {brandName && <div>Brand: {brandName}</div>}
                                        {
                                            isChecked2.length > 0 && <div>
                                                Product Status : {filterProductStatusName && filterProductStatusName.map((val, key) => {
                                                    return <span key={key}>{val.product_status_name} </span>
                                                })}
                                            </div>
                                        }

                                        <div>Pending Till: {moment(form.getFieldValue().as_on_date).format("MM-DD-YYYY")}</div>
                                    </div>
                                    <Table
                                        className=" border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style border prod-table omsTable"
                                        ref={tableRef}
                                        size="small"
                                        bordered={false}
                                        type="company"
                                        dataSource={data && data}
                                        columns={columns}
                                        scroll={{ x: 'max-content' }}
                                        loading={omsStockStyleWiseSummary.loading}
                                        onChange={handleTableChange}
                                        pagination={{
                                            defaultCurrent: 1,
                                            defaultPageSize: 500,
                                            pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                                        }}
                                        summary={(pageData) => {
                                            return (
                                                <>
                                                    <Table.Summary.Row>
                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                        <Table.Summary.Cell><p style={{ textAlign: "center", margin: "0" }}>
                                                            Total &gt; &gt; &gt;
                                                        </p></Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "center", margin: "0" }} className="totalquantity">
                                                                {numeral(itemCodeTotal).format('0,0')}
                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(berganTotal).format('0,0')}
                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(transitTotal).format('0,0')}

                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(pkTotal).format('0,0')}

                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(productionTotal).format('0,0')}

                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(pendingTotal).format('0,0')}

                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(otsTotal).format('0,0')}

                                                            </p>
                                                        </Table.Summary.Cell>
                                                        <Table.Summary.Cell>
                                                            <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                                                {numeral(podTotal).format('0,0')}

                                                            </p>
                                                        </Table.Summary.Cell>

                                                    </Table.Summary.Row>
                                                </>
                                            );
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className="no-Data">
                                    <h1>No Data</h1>
                                </div>

                            )
                        ) : (
                            loading && (
                                <div className="loader" style={{ marginTop: "20px" }}>
                                    <Spin size="medium" />
                                </div>
                            )
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default OMSStockStyleWiseSummary;
